import React, { useMemo } from 'react';
import { TeamWithCount } from '@shared/models/team.models';
import { BodySmall } from '../../atoms/fonts/Body';
import './team-drop-down-list.scss';
import Colours from "../../atoms/Colours";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { REACT_SELECT_DROPDOWN_STYLES } from "../OfficeDropDownList";
import i18next from "i18next";

export const ALL_TEAMS = 'ALL';
const animatedComponents: any = makeAnimated();

export default function TeamDropDownList(props: Props) {
  const { onSelect, selectedTeamId, className, label } = props;
  const {t} = useTranslation();

  const onItemSelected = (e: any) => {
    if (e.value && e.value !== 'none') {
      onSelect(e.value)
    }
  }

  const options = useMemo(() => {
    let retVal: any = [];
    if (props.includeAllTeams) {
      retVal.push({
        value: ALL_TEAMS,
        label: i18next.t('general.all-teams'),
      })
    }

    (props.teams ?? []).forEach(t => retVal.push({
      value: t.id,
      label: t.name,
    }))

    return retVal;

  }, [props.includeAllTeams, props.teams])

  return (
    <>
      {!!label && <BodySmall colour={Colours.darkGrey} weight={600} className="teamDropDownList__label">{t(label)}</BodySmall>}
      <Select
        options={options}
        onChange={onItemSelected}
        value={options.find((o: any) => o.value === selectedTeamId)}
        closeMenuOnSelect={true}
        // Render the menu in a body portal so it can overflow constrained containers (e.g. the
        // "Add Project / Event" dialog) instead of being clipped by them.
        menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
        menuPosition="fixed"
        // zIndex must clear the dialog overlay (.dialog__animationContainer is 99999).
        styles={{ ...REACT_SELECT_DROPDOWN_STYLES, menuPortal: (base: any) => ({ ...base, zIndex: 999999 }) }}
        components={{ ...animatedComponents, ClearIndicator:() => null, IndicatorSeparator:() => null }}
        isMulti={false}
        isDisabled={props.disabled} className={`teamDropDownList ${className ?? ''}`.trim()}
      />
    </>
  )
}


interface Props {
  teams: TeamWithCount[],
  onSelect: (teamId: string) => any,
  selectedTeamId?: string,
  className?: string,
  label?: string,
  disabled?: boolean,
  includeAllTeams?: boolean,
}
